export default function CreateBrandIcon() {
  return (
    <svg
      width="67"
      height="67"
      viewBox="0 0 67 67"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Create Brand Icon</title>
      <rect
        x="66.3213"
        y="0.738281"
        width="66"
        height="66"
        rx="16"
        transform="rotate(90 66.3213 0.738281)"
        fill="white"
        fillOpacity="0.05"
      />
      <path
        d="M47.0326 24.1967L35.9022 17.2402C35.1282 16.7565 34.2339 16.5 33.3213 16.5C32.4086 16.5 31.5143 16.7565 30.7404 17.2402L19.61 24.1967C18.9092 24.6347 18.3314 25.2438 17.931 25.9667C17.5307 26.6896 17.3208 27.5025 17.3213 28.3289V39.4593C17.3208 40.2857 17.5307 41.0986 17.931 41.8215C18.3314 42.5444 18.9092 43.1535 19.61 43.5915L30.7404 50.548C31.5177 51.0225 32.4107 51.2736 33.3213 51.2736C34.2319 51.2736 35.1249 51.0225 35.9022 50.548L47.0326 43.5915C47.7334 43.1535 48.3111 42.5444 48.7115 41.8215C49.1119 41.0986 49.3218 40.2857 49.3213 39.4593V28.3289C49.3218 27.5025 49.1119 26.6896 48.7115 25.9667C48.3111 25.2438 47.7334 24.6347 47.0326 24.1967ZM21.4952 27.9463L31.2343 21.8593V32.7115L21.4952 38.555V27.9463ZM33.3213 47.2367L24.4169 41.6715L33.3213 36.3289L42.2256 41.6715L33.3213 47.2367ZM45.1474 38.555L35.4082 32.7115V21.8593L45.1474 27.9463V38.555Z"
        fill="white"
      />
    </svg>
  );
}
